// import Toast from '@locus-labs/mol-mobile-toast'
import React, { useState, useEffect } from 'react'

import Toast from '../../../../src/ui/toast/ToastComponent.jsx'
import { StateObj } from '../../../../src/utils/stateObj.js'

const ToastView = ({ widgetState, onToastDismiss, isDesktop, T }) => {
  const [state, setWidgetState] = useState(widgetState.getState())
  useEffect(() => widgetState.setCallback(setWidgetState))
  return <Toast
    position="absolute"
    top="0"
    zIndex={20000}
    onToastDismiss={onToastDismiss}
    isDesktop={isDesktop}
    T={T}
    {...state}
  >{state.message}</Toast>
}

function create (app) {
  const init = () => { }
  const widgetState = new StateObj({ shouldDisplay: false })
  const T = app.gt()
  const theme = app.themePack.getTheme()
  app.bus.send('layers/register', {
    id: 'toast',
    widget: () => <ToastView
      widgetState={widgetState}
      onToastDismiss={() => widgetState.update({ shouldDisplay: false })}
      isDesktop={app.env.isDesktop()}
      T={T}
    />,
    show: true,
    isOverlay: true,
    layoutId: 'toast'
  })

  const propsFromVariant = (variant) => {
    if (variant === 'success')
      return {
        iconName: 'success',
        background: theme.colors.statusSuccessBackground,
        color: theme.colors.statusSuccessText
      }
    else if (variant === 'warning')
      return {
        iconName: 'warning',
        background: theme.colors.statusWarningBackground,
        color: theme.colors.statusWarningText
      }
    else if (variant === 'info') {
      return {
        iconName: 'info',
        background: theme?.colors?.toolTipBackground,
        color: theme?.colors?.toolTipText
      }
    }
    return {}
  }

  app.bus.on('toast/show', ({ variant, ...props }) => {
    const variantProps = propsFromVariant(variant)
    widgetState.update({
      ...props,
      ...variantProps,
      shouldDisplay: true
    })
  })

  return {
    init
  }
}

export {
  create
}
